import React from "react";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";

export class AppLinksHoldingDrawer extends React.Component {
  state = {
    savingOptions: false,
    android: null,
    ios: null,
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async componentDidMount() {
    const selectedEnvironment =
      await EnvironmentStorage.getEnvironmentHoldingId();
    const appsResponse = await EnvironmentsAPI.getConfigurationsByAlias(
      selectedEnvironment,
      "apps"
    );

    const android_link = appsResponse?.android_link;
    const ios_link = appsResponse?.ios_link;
    this.setState({
      android_link,
      ios_link,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { android_link, ios_link } = this.state;

      await this.setAsyncState({ savingOptions: true });

      const selectedEnvironment =
        await EnvironmentStorage.getEnvironmentHoldingId();
      let apps = await EnvironmentsAPI.getConfigurationsByAlias(
        selectedEnvironment,
        "apps"
      );

      apps.android_link = android_link;
      apps.ios_link = ios_link;

      const response = await EnvironmentsAPI.putConfigurationsByAlias(
        selectedEnvironment,
        "apps",
        {
          apps: apps,
        }
      );
      await this.setAsyncState({ savingOptions: false });

      if (response.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível salvar: ${response.getErrors()[0]}`,
        });
      }
    } catch (e) {
      await this.setAsyncState({ savingOptions: false });
    }
  }

  render() {
    const { visible, onClose } = this.props;
    const { android_link, ios_link, savingOptions } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Links de aplicativo"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={this.onSave.bind(this)}
            loading={savingOptions}
            disabled={savingOptions}
          >
            Salvar alterações
          </Button>
        }
      >
        <Input
          design="two"
          className="mb-15"
          floatLabel="Android"
          value={android_link}
          onChange={(e) => this.setState({ android_link: e.target.value })}
        />
        <Input
          design="two"
          className="mb-15"
          floatLabel="iOS"
          value={ios_link}
          onChange={(e) => this.setState({ ios_link: e.target.value })}
        />
      </Drawer>
    );
  }
}
